import { z } from "zod";

import { FilterFieldConfig } from "@/modules/common/filters";
import useAdminUsersOptions from "@/modules/common/hooks/lists/useAdminUsersOptions";
import { LEAD_ORIGIN_OPTIONS, LEAD_SEGMENT_OPTIONS, LEAD_STATUS_OPTIONS, LeadOrigin, LeadStatus } from "@/modules/common/types/Leads.enum";

const leadStatusesSchema = z.array(z.enum(LeadStatus));
const leadOriginsSchema = z.array(z.enum(LeadOrigin));

export interface LeadFilters {
  search?: string;
  status?: LeadStatus[];
  origin?: LeadOrigin[];
  segment?: string;
  responsibleById?: string;
  createdAtAfter?: string;
  createdAtBefore?: string;
}

export const LEAD_FILTER_FIELDS: FilterFieldConfig[] = [
  {
    key: "search",
    label: "Buscar por nome, empresa ou e-mail",
    type: "text",
    placement: "inline",
    schema: z.string(),
  },
  {
    key: "status",
    label: "Status",
    type: "select-multiple",
    placement: "both",
    schema: leadStatusesSchema,
    options: LEAD_STATUS_OPTIONS,
    serialize: (value: LeadStatus[] | undefined) => (value?.length ? value.join(",") : undefined),
    deserialize: (raw) => {
      const parsed = leadStatusesSchema.safeParse((raw ?? "").split(",").filter(Boolean));
      return parsed.success && parsed.data.length ? parsed.data : undefined;
    },
  },
  {
    key: "origin",
    label: "Origem",
    type: "select-multiple",
    placement: "both",
    schema: leadOriginsSchema,
    options: LEAD_ORIGIN_OPTIONS,
    serialize: (value: LeadOrigin[] | undefined) => (value?.length ? value.join(",") : undefined),
    deserialize: (raw) => {
      const parsed = leadOriginsSchema.safeParse((raw ?? "").split(",").filter(Boolean));
      return parsed.success && parsed.data.length ? parsed.data : undefined;
    },
  },
  {
    key: "segment",
    label: "Segmento",
    type: "select",
    placement: "modal",
    schema: z.string(),
    options: LEAD_SEGMENT_OPTIONS,
  },
  {
    key: "responsibleById",
    label: "Responsável",
    type: "select-async",
    placement: "modal",
    schema: z.string(),
    useOptions: useAdminUsersOptions,
  },
  {
    key: "createdAt",
    label: "Recebido em",
    type: "period",
    placement: "modal",
    schema: z.any(),
    inputs: [
      {
        key: "createdAtAfter",
        label: "Recebido após",
        type: "date",
        schema: z.string(),
      },
      {
        key: "createdAtBefore",
        label: "Recebido até",
        type: "date",
        schema: z.string(),
      },
    ],
  },
];
